import type { EdgeChange, NodeChange } from "@xyflow/react";

/** Persistence policy for the production canvas's XYFlow event batches. */
export function shouldPersistNodeChanges(changes: readonly NodeChange[]): boolean {
  return changes.some(change => {
    if (change.type === "select") return false;
    // This page's XYFlow dragging and keyboard-move events explicitly end with
    // dragging:false, sometimes without another position value.
    if (change.type === "position") return change.dragging === false;
    if (change.type === "dimensions") return change.dimensions !== undefined &&
      (change.setAttributes === true || change.setAttributes === "width" || change.setAttributes === "height");
    return true;
  });
}

export function shouldPersistEdgeChanges(changes: readonly EdgeChange[]): boolean {
  return changes.some(change => change.type !== "select");
}
